export default {"src":"/_next/static/media/white_quick_view_hover.5878c225.svg","height":19,"width":30,"blurWidth":0,"blurHeight":0};